






















































interface Category {
  _key: string;
  icon: string;
  name: string;
  link?: string; // 页面link
  pathname?: string; // 如果有二级菜单，用来计算当前选择的菜单index
  pages?: Page[];
}
interface Page {
  _key: string;
  name: string;
  children?: Children[];
}
interface Children {
  _key: string;
  name: string;
  link?: string;
}
import { Component, Watch, Vue } from 'vue-property-decorator';
import { State, Mutation, Action } from 'vuex-class';
import store from '@/store/index';
const uuidv4 = require('uuid/v4');
import Cookies from 'js-cookie';
import { MUTATION_LOG_ON_OUT, MUTATION_SET_MENU } from '@/store/type';
import storage from 'baimahu/storage';
import { ACTION_GET_PERMISSION } from '@/store/type';
const { VUE_APP_FCREST: FCREST } = process.env;
const API = {
  userInfo: `${FCREST}/promotion/shang/merchant`,
};
const package_type = (storage.getItem('profile') || {}).package_type || 1;

const MENU: Category[] = [
  {
    _key: uuidv4(),
    icon: 'home',
    name: '概况',
    link: '/home/index',
  },
  {
    _key: uuidv4(),
    icon: 'appstore',
    name: '商品',
    link: '/ware/list',
    pathname: 'ware',
  },
  {
    _key: uuidv4(),
    icon: 'gift',
    name: '营销',
    pathname: 'promotion',
    link: '/promotion/coupon',
    pages: [
      {
        _key: uuidv4(),
        name: '',
        children: [
          {
            _key: uuidv4(),
            name: '优惠券',
            link: '/promotion/coupon',
          },
          // {
          //   _key: uuidv4(),
          //   name: '砍价',
          //   link: '/promotion/bargain',
          // },
          // {
          //   _key: uuidv4(),
          //   name: '拼团',
          //   link: '/promotion/group',
          // },
        ],
      },
    ],
  },
  {
    _key: uuidv4(),
    icon: 'solution',
    name: '订单',
    link: '/order/list',
  },
  {
    _key: uuidv4(),
    icon: 'message',
    name: '分销',
    link: '/sale/list',
  },
  {
    _key: uuidv4(),
    icon: 'property-safety',
    name: '财务',
    pathname: 'finance',
    link: '/finance/list',
  },
  {
    _key: uuidv4(),
    icon: 'setting',
    name: '设置',
    pathname: 'setting',
    link: '/setting/basic-info',
    pages: [
      {
        _key: uuidv4(),
        name: '通用设置',
        children: [
          {
            _key: uuidv4(),
            name: '基础信息',
            link: '/setting/basic-info',
          },
          {
            _key: uuidv4(),
            name: '交易设置',
            link: '/setting/trade',
          },
        ],
      },
      {
        _key: uuidv4(),
        name: '小程序设置',
        children: [
          {
            _key: uuidv4(),
            name: '微信授权',
            link: '/setting/authorize',
          },
          {
            _key: uuidv4(),
            name: '支付绑定',
            link: '/setting/payment',
          },
          {
            _key: uuidv4(),
            name: '发布管理',
            link: '/setting/release',
          },
        ],
      },
      // {
      //   _key: uuidv4(),
      //   name: '账号设置',
      //   children: [
      //     {
      //       _key: uuidv4(),
      //       name: '账号管理',
      //       link: '/setting/account',
      //     },
      //   ]
      // }
      // {
      //   _key: uuidv4(),
      //   name: '其它设置',
      //   children: [
      //     {
      //       _key: uuidv4(),
      //       name: '区域管理',
      //       link: '/setting/region',
      //     },
      //   ],
      // },
    ],
  },
];
function Children(remote: any) {
  const children: Children = {
    _key: uuidv4(),
    name: remote.name,
    link: remote.link,
  };
  return children;
}
function getPage(remote: any) {
  const page: Page = {
    _key: uuidv4(),
    name: remote.name,
    children: remote.children || [],
  };
  return page;
}
function getCategory(remote: any) {
  const category: Category = {
    _key: uuidv4(),
    icon: remote.icon || '',
    name: remote.name || '',
    link: remote.link || '',
    pathname: remote.pathname || '',
    pages: remote.pages || [],
  };
  return category;
}

@Component
export default class AppAside extends Vue {
  @State('basis') basis!: Business.Basis;
  @State('permission') permission!: any;
  @Action(ACTION_GET_PERMISSION) getPermission!: () => any;
  @Mutation(MUTATION_LOG_ON_OUT) logOnOut: any;
  @Mutation(MUTATION_SET_MENU) setMenu: any;
  menu: Category[] = [];
  activeRoutePath: string = '';
  menuItem: object = {};
  menuItemIndex: number = 0;
  package_type: number = 1;
  get logo() {
    return this.basis.logo || require('@/asset/img/logo-default.png');
  }

  @Watch('$route')
  onRouteChange(to: any, from: any) {
    if (from.path === '/login') {
      this.changeMenu(this.menu[0], 0);
    }
    this.menu.forEach((item: any, index: any) => {
      if (to.path === item.link) {
        this.changeMenu(this.menu[index], index);
      }
      if (item.pathname) {
        const pathArr = this.$route.path.split('/');
        if (item.pathname === pathArr[1]) {
          this.changeMenu(this.menu[index], index);
        }
      }
    });
    this.setActiveRoutePath(to);
  }

  setActiveRoutePath(route: any) {
    let activeRoutePath: string = route.path;
    if (/^\/ware\/edit/.test(activeRoutePath)) {
      activeRoutePath = '/ware/list';
    }
    if (/^\/operation\/carousel-detail/.test(activeRoutePath)) {
      activeRoutePath = '/operation/carousel-list';
    }
    this.activeRoutePath = activeRoutePath;
  }

  changeMenu(item: any, index: number) {
    console.debug('changeMenu', item, index);
    this.loginStatus();
    this.menuItem = item;
    this.menuItemIndex = index;
  }

  loginStatus() {
    const isLogin = !!storage.getItem('profile');
    if (!isLogin) {
      this.$router.push('/login');
      this.logOnOut(false);
    }
  }

  defaultOpenKeys(pages: any) {
    const keys: any = [];
    pages.forEach((item: any) => {
      keys.push(item._key);
    });
    return keys;
  }

  async fetchMenu() {
    const menu: Category[] = MENU.map((item: any) => getCategory(item));
    await Promise.resolve();
    return menu;
  }

  async getUser() {
    this.menu = await this.fetchMenu();
    this.setActiveRoutePath(this.$route);
    const profile = storage.getItem('profile') || {};
    const activated_module = profile.activated_module || [];
    const activity_module_id = 1;
    const last_obj: any = {
      _key: uuidv4(),
      name: '其它设置',
      children: [],
    };
    if (activated_module.includes(activity_module_id)) {
      const obj = {
        _key: uuidv4(),
        icon: 'notification',
        name: '活动',
        link: '/activity/list',
      };
      last_obj.children.unshift({
        _key: uuidv4(),
        name: '区域管理',
        link: '/setting/region',
      });
      this.menu.splice(1, 0, obj);
      const last_menu: any = this.menu[this.menu.length - 1];
      if (last_menu.pages && last_obj.children.length > 0) {
        last_menu.pages.splice(last_menu.pages.length, 0, last_obj);
      }
      this.menu.forEach((item: any, index: any) => {
        const pathArr = this.$route.path.split('/');
        if (item.pathname) {
          if (item.pathname === pathArr[1]) {
            this.menuItemIndex = index;
            this.menuItem = item;
          }
        } else {
          if (item.link === this.$route.path) {
            this.menuItemIndex = index;
            this.menuItem = item;
          }
          if (this.$route.path === '/finance/detail') {
            this.menuItemIndex = 6;
          }
          if (pathArr[1] === 'activity') {
            this.menuItemIndex = 1;
          }
          if (pathArr[1] === 'ware') {
            this.menuItemIndex = 2;
          }
          if (pathArr[1] === 'sale') {
            this.menuItemIndex = 5;
          }
        }
      });
    } else {
      this.menu.forEach((item: any, index: any) => {
        const pathArr = this.$route.path.split('/');
        if (item.pathname) {
          if (item.pathname === pathArr[1]) {
            this.menuItemIndex = index;
            this.menuItem = item;
          }
        } else {
          if (item.link === this.$route.path) {
            this.menuItemIndex = index;
            this.menuItem = item;
          }
          if (this.$route.path === '/finance/detail') {
            this.menuItemIndex = 5;
          }
          if (pathArr[1] === 'ware') {
            this.menuItemIndex = 1;
          }
          if (pathArr[1] === 'sale') {
            this.menuItemIndex = 4;
          }
        }
      });
    }

    if (this.package_type === 2) {
      this.menu.forEach((item: any) => {
        if (item.name === '财务') {
          item.pages = [
            {
              _key: uuidv4(),
              name: '',
              children: [
                {
                  _key: uuidv4(),
                  name: '财务提现',
                  link: '/finance/list',
                },
                {
                  key: uuidv4(),
                  name: '合同列表',
                  link: '/finance/contract-list',
                },
              ],
            },
          ];
        }
        if (item.name === '商品') {
          item.pages = [
            {
              _key: uuidv4(),
              name: '',
              children: [
                {
                  _key: uuidv4(),
                  name: '商品管理',
                  link: '/ware/list',
                },
                {
                  _key: uuidv4(),
                  name: '商品分类',
                  link: '/ware/category-list',
                },
              ],
            },
          ];
        }
        if (item.name === '设置') {
          item.pages.push({
            _key: uuidv4(),
            name: '账号设置',
            children: [
              {
                _key: uuidv4(),
                name: '账号管理',
                link: '/setting/account',
              },
            ],
          });
        }
      });
      last_obj.children.push({
        _key: uuidv4(),
        name: '软装管家',
        link: '/setting/housekeeper',
      });
      const user_module = {
        _key: uuidv4(),
        icon: 'user',
        name: '用户',
        pathname: 'user',
        link: '/user/user-list',
        pages: [
          {
            _key: uuidv4(),
            name: '',
            children: [
              {
                _key: uuidv4(),
                name: '用户总表',
                link: '/user/user-list',
              },
              {
                _key: uuidv4(),
                name: '下订用户',
                link: '/user/order-user',
              },
              {
                _key: uuidv4(),
                name: '签约用户',
                link: '/user/signed-user',
              },
            ],
          },
        ],
      };
      this.menu.splice(1, 0, user_module);
      const obj = {
        _key: uuidv4(),
        icon: 'schedule',
        name: '运营',
        pathname: 'setting',
        link: '/operation/ruan-set-meal',
        pages: [
          {
            _key: uuidv4(),
            name: '样板间管理',
            children: [
              {
                _key: uuidv4(),
                name: '软装样板间',
                link: '/operation/ruan-set-meal',
              },
            ],
          },
          {
            _key: uuidv4(),
            name: '风格管理',
            children: [
              {
                _key: uuidv4(),
                name: '风格列表',
                link: '/operation/style-list',
              },
              {
                _key: uuidv4(),
                name: '设计风格',
                link: '/operation/design-works',
              },
            ],
          },
          {
            _key: uuidv4(),
            name: '案例管理',
            children: [
              {
                _key: uuidv4(),
                name: '小区列表',
                link: '/operation/community-list',
              },
              {
                _key: uuidv4(),
                name: '兔狗作品',
                link: '/operation/community-template',
              },
              {
                _key: uuidv4(),
                name: '实景案例',
                link: '/operation/sence-example',
              },
            ],
          },
          {
            _key: uuidv4(),
            name: '页面配置',
            children: [
              {
                _key: uuidv4(),
                name: '首页配置',
                link: '/operation/home-page',
              },
              {
                _key: uuidv4(),
                name: '轮播配置',
                link: '/operation/carousel-list',
              },
            ],
          },
        ],
      };
      this.menu.splice(1, 0, obj);
    }
    if (this.package_type === 1) {
      this.menu.forEach((item: any) => {
        if (item.name === '设置') {
          const obj = {
            _key: uuidv4(),
            name: '页面配置',
            children: [
              {
                _key: uuidv4(),
                name: '首页配置',
                link: '/operation/home-page-standard',
              },
              {
                _key: uuidv4(),
                name: '轮播配置',
                link: '/operation/carousel-list',
              },
            ],
          };
          item.pages.splice(2, 0, obj);
        }
        if (item.name === '商品') {
          item.pages = [
            {
              _key: uuidv4(),
              name: '',
              children: [
                {
                  _key: uuidv4(),
                  name: '商品管理',
                  link: '/ware/list',
                },
                {
                  _key: uuidv4(),
                  name: '商品分类',
                  link: '/ware/category-list',
                },
              ],
            },
          ];
        }
      });
    }
  }
  async created() {
    this.package_type = (storage.getItem('profile') || {}).package_type || 1;
    await this.getUser();
    await this.getPermission();
    const profile = storage.getItem('profile');
    if (profile.auth_set_list !== 'all') {
      const auth_set_list = profile.auth_set_list.split(',').map((item: any) => +item);
      let menu_name_arr: any = [];
      this.permission.forEach((item: any) => {
        if (auth_set_list.indexOf(item.id) !== -1) {
          menu_name_arr.push(item.name);
        }
      });
      menu_name_arr = [...new Set(menu_name_arr)];
      const new_menu: any = [];
      this.menu.forEach((item: any) => {
        if (menu_name_arr.indexOf(item.name) !== -1 || item.name === '概况') {
          new_menu.push(item);
        }
      });
      this.menu = new_menu;
      this.setMenu(this.menu);
    }
  }
}
